import {combineReducers} from 'redux';
import account from './account';
import companies from './companies';
import books from './books';
import contacts from './contacts';
import products from './products'
import dashboard from './dashboard';
import jobs from './JobsList';
import opportunitiesList from './opportunitiesList';
import opportunity from './opportunity';
import sales from './sales';
import salesList from './salesList';
import admin from './admin';
import divisions from './divisions';
import eventsOverview from './eventsOverview';
import users from './users';

const rootReducer = combineReducers({
    account,
    opportunity,
    sales,
    contacts,
    companies,
    books,
    products,
    dashboard,
    jobs,
    opportunitiesList,
    salesList,
    divisions,
    admin,
    eventsOverview,
    users,
});

export default rootReducer;